<app-checkout-app
  [editMode]="!!duplicateValues"
  [isDuplicate]="!!duplicateValues"
  [loadValues]="duplicateValues"
  (submitForm)="onSubmit($event)"
  [isLoading]="isLoading"></app-checkout-app>
